import { OutstandingTransactionsComingSoonModal } from '../../OutstandingTransactionsComingSoon/corporate-cards-settings-modal/OutstandingTransactionsComingSoonModal/OutstandingTransactionsComingSoonModal'
import { AllCardsCorporateList } from './AllCardsCorporateList'

export const AllCardsCorporate = () => {
  return (
    <>
      <OutstandingTransactionsComingSoonModal />
      <AllCardsCorporateList />
    </>
  )
}
